import React, {
    useEffect, RefObject, Dispatch
} from "react";
import getConfig from "next/config";
import { JobSearchHit } from "@themuse/design-system";

import styles from "./SideBySideJDP.module.scss";

/**
 * Generates a URL for a side-by-side job description Iframe.
 */
export const generateSideBySideUrl = (job: JobSearchHit) => {
    const { publicRuntimeConfig: { museWebHost } } = getConfig();
    const { company: { short_name: param1 }, short_title: param2 } = job.hit;
    return param1 && param2 ? `${museWebHost}/jobs/${param1}/${param2}?framed` : "";
};

interface SideBySideJDPProps {
    iframeRef: RefObject<HTMLDivElement>;
    isOpen: boolean;
    setIsOpen: Dispatch<React.SetStateAction<boolean>>;
    selectedJob: JobSearchHit;
    setSelectedJob: Dispatch<React.SetStateAction<JobSearchHit>>;
}

const Iframe = ({ isOpen, iframeURL }) => (
    <iframe
        className={styles.frame}
        title="JDP"
        loading="lazy"
        key={iframeURL}
        src={isOpen && iframeURL ? iframeURL : ""}
    />
);

export const SideBySideJDP: React.FC<SideBySideJDPProps> = ({
    iframeRef,
    isOpen,
    setIsOpen,
    selectedJob,
    setSelectedJob
}) => {
    const iframeURL = selectedJob ? generateSideBySideUrl(selectedJob) : "";

    // Iframe close listener wipe selected job, iframe url and close the iframe.
    useEffect(() => {
        const onReceivedCloseMessage = (event: { data: string; }) => {
            if (event.data === "closeSideBySide") {
                setSelectedJob(null);
                setIsOpen(false);
            }
        };

        window.addEventListener("message", onReceivedCloseMessage);

        return () => {
            window.removeEventListener("message", onReceivedCloseMessage);
        };
    }, []);

    return (
        <div ref={iframeRef} className={`${styles.frameWrapper} ${isOpen ? styles.frameWrapper_open : ""}`}>
            <Iframe {...{ isOpen, iframeURL }} />
        </div>

    );
};
SideBySideJDP.displayName = "SideBySideJDP";
